import React, { useState, useEffect, useContext } from 'react'
import AdminContext from '../../StateContext/Application'
import { apiurl } from '../../../../path'
import { useLanguage } from '../../../../lang/langcontext/LanguageContext'
import GooglePagination from '../../styles/GooglePagination'

const VendorReport = () => {
    const { language, toggleLanguage, t } = useLanguage();
    const context = useContext(AdminContext)
    const { GetAllContractorList } = context
    const [contractor, setContractorList] = useState([])
    const [filteredBills, setFilteredBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCompany, setSelectedCompany] = useState("");
    const [selectedCity, setSelectedCity] = useState("");


    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
     const sortedBills = Array.isArray(filteredBills)? filteredBills.slice() // ✅ prevent state mutation
.sort((a, b) => new Date(b.Date) - new Date(a.Date))
        : [];
    const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);

    const getContractorList = async () => {
        let data = await GetAllContractorList()
        console.log("data", data);

        setContractorList(data)
        setFilteredBills(data);
    }
    useEffect(() => {
        getContractorList()
    }, [])
    let contractorList = []
    if (contractor.length > 0) {
        contractorList = contractor
    }
    // useEffect(() => {
    //     let filtered = contractor;

    //     if (selectedCompany) {
    //         filtered = filtered.filter(item => item.Bidder_CompanyName === selectedCompany);
    //     }

    //     if (selectedCity) {
    //         filtered = filtered.filter(item => item.City === selectedCity);
    //     }

    //     setFilteredBills(filtered);
    //     setCurrentPage(1); // Reset pagination
    // }, [selectedCompany, selectedCity, contractor]);

    useEffect(() => {
        const term = searchTerm.toLowerCase();
        const filtered = contractor.filter(bill =>
            Object.values(bill).some(val =>
                (val || '').toString().toLowerCase().includes(term)
            )
        );
        setFilteredBills(filtered);
        setCurrentPage(1);
    }, [searchTerm, contractor]);


     return (

        <>
            <div className="col-12" style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">

                    <div className="col-12">

                        <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            {/* <h4 style={{ margin: "10px 0px" }}></h4> */}
                            <h5 className='my-auto fw-bold'>
                                <img src="/GR-Approval64.png" alt="Vendor Report" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
                                <span className='my-auto'>{t("Vendor Report")}</span>
                            </h5>
                            {/* <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)}
                            value={searchTerm}
                            style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} /> */}

                            <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
                                <img
                                    src="/Search32.png"
                                    alt="Search Icon"
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "10px",
                                        transform: "translateY(-50%)",
                                        width: "16px",
                                        height: "16px",
                                        opacity: 0.6
                                    }}
                                />
                                <input
                                    type="text"
                                    placeholder={t("Search Here")}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    value={searchTerm}
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px 8px 32px", // left padding makes space for icon
                                        border: "1px solid #ccc",
                                        borderRadius: "8px",
                                        backgroundColor: "#f1f6fc",
                                        fontSize: "14px",
                                        color: "#333",
                                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                        outline: "none"
                                    }}
                                />
                            </div>
                        </div>

                        <div className="col-12 pb-5">
                            <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%",maxWidth:"100%",overflowX:"hidden" }}>
                                <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
                                    <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                                                {/* <th style={{ width: "8%" }}>Vendor ID</th> */}
                                                <th style={{ minWidth: "40px", padding: "8px" }}>{t("Sr.no.")}</th>
                                                <th style={{ minWidth: "160px", padding: "8px" }}>{t("Company Name")}</th>
                                                <th style={{ minWidth: "160px", padding: "8px" }}>{t("Address")}</th>
                                                <th style={{ minWidth: "100px", padding: "8px" }}>{t("Mobile No")}</th>
                                                <th style={{ minWidth: "160px", padding: "8px" }}>{t("Email")}</th>
                                                <th style={{ minWidth: "50px", padding: "8px" }}>{t("Pincode")}</th>
                                                <th style={{ minWidth: "90px", padding: "8px" }}>{t("City")}</th>
                                                <th style={{ minWidth: "100px", padding: "8px" }}>{t("Pan Number")}</th>
                                                <th style={{ minWidth: "100px", padding: "8px" }}>{t("Tan Number")}</th>
                                                <th style={{ minWidth: "100px", padding: "8px" }}>{t("GST Number")}</th>
                                                <th style={{ minWidth: "130px", padding: "8px" }}>{t("Aadhaar Number")}</th>
                                                <th style={{ minWidth: "100px", padding: "8px" }}>{t("IFSC Code")}</th>
                                                <th style={{ minWidth: "100px", padding: "8px" }}>{t("MICR Code")}</th>
                                                <th style={{ minWidth: "100px", padding: "8px" }}>{t("Bank Name")}</th>
                                                <th style={{ minWidth: "100px", padding: "8px" }}>{t("Branch Name")}</th>
                                                <th style={{ minWidth: "140px", padding: "8px" }}>{t("Account Number")}</th>
                                                <th style={{ minWidth: "230px", padding: "8px" }}>{t("Paasbook Doc")}</th>
                                                <th style={{ minWidth: "230px", padding: "8px" }}>{t("Cheque Doc")}</th>
                                                <th style={{ minWidth: "230px", padding: "8px" }}>{t("Pan Doc")}</th>
                                                <th style={{ minWidth: "230px", padding: "8px" }}>{t("Tan Doc")}</th>
                                                <th style={{ minWidth: "230px", padding: "8px" }}>{t("GST Doc")}</th>
                                                <th style={{ minWidth: "230px", padding: "8px" }}>{t("Aadhaar Doc")}</th>
                                                <th style={{ minWidth: "160px", padding: "8px" }}>{t("Creation Date")}</th>
                                            </tr>
                                        </thead>
                                        {currentBills?.length === 0 ? (
                                            <tr>
                                                <td colSpan="20" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                                                    {t("No data available")}
                                                </td>
                                            </tr>
                                        ) : (
                                            currentBills?.map((contractor, index) => {
                                                const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                return (
                                                    <tbody>
                                                        <tr key={index} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "500" }}>
                                                            <td style={{ padding: '8px' }}>{(currentPage - 1) * billsPerPage + index + 1}</td>
                                                            <td style={{ padding: '8px' }}>{contractor.Bidder_CompanyName}</td>
                                                            <td style={{ padding: '8px' }}>{contractor.Address}</td>
                                                            <td style={{ padding: '8px' }}>{contractor.Mobile_No}</td>
                                                            <td style={{ padding: '8px' }}>{contractor.Email}</td>
                                                            <td style={{ padding: '8px' }}>{contractor.PinCode}</td>
                                                            <td style={{ padding: '8px' }}>{contractor.City}</td>
                                                            <td style={{ padding: '8px' }}>{contractor.PAN_No}</td>
                                                            <td style={{ padding: '8px' }}>{contractor.TAN_No}</td>
                                                            <td style={{ padding: '8px' }}>{contractor.GST_No}</td>
                                                            <td style={{ padding: '8px' }}>{contractor.AadhaarNo}</td>
                                                            <td style={{ padding: '8px' }}>{contractor.IFSC_CODE}</td>
                                                            <td style={{ padding: '8px' }}>{contractor.MICR_No}</td>
                                                            <td style={{ padding: '8px' }}>{contractor.BANK_NAME}</td>
                                                            <td style={{ padding: '8px' }}>{contractor.BranchName}</td>
                                                            <td style={{ padding: '8px' }}>{contractor.Account_Number}</td>
                                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${contractor.PaasbookDoc}`} target='_blank'>{contractor.PaasbookDoc}</a></td>
                                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${contractor.ChequeDoc}`} target='_blank'>{contractor.ChequeDoc}</a></td>
                                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${contractor.PanDoc}`} target='_blank'>{contractor.PanDoc}</a></td>
                                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${contractor.TanDoc}`} target='_blank'>{contractor.TanDoc}</a></td>
                                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${contractor.GstDoc}`} target='_blank'>{contractor.GstDoc}</a></td>
                                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${contractor.AadharDoc}`} target='_blank'>{contractor.AadharDoc}</a></td>
                                                            <td style={{ padding: '8px' }}>{new Date(contractor.Date).toLocaleString()}</td>
                                                        </tr>
                                                    </tbody>
                                                );
                                            })
                                        )}
                                    </table>
                                </div>


                                <div className='col-12 mt-4'>
                                    <div className="row">
                                        <div className='col-6'>
                                            <p className="text-gray-600" style={{ fontSize: "14px" }}>
                                                {t("Showing")} {indexOfFirstBill + 1} {t("to")} {Math.min(indexOfLastBill, filteredBills.length)} {t("of")} {contractor.length} {t("entries")}
                                            </p>
                                        </div>
                                        <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
                                            <GooglePagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                onPageChange={setCurrentPage}
                                            />
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default VendorReport
